import React from "react";
import { bulletIcon } from "../../../assets/icons";
import { Button } from "../..";
import "./index.scss";

export default function MissionSectionCard({ data, noButton, inverted }) {
	const addedStyle = inverted && "inverted";

	return (
		<ul className={`mission-section-cards ${addedStyle}`}>
			{data?.map(
				({ imageSource, heading, subHeading, description, link }) => (
					<li className="section-card">
						<div className="img-container">
							<img src={imageSource} alt="" />
						</div>

						<div className="texts-wrapper">
							<p className="mb-0">{heading}</p>

							<h2>{subHeading && subHeading}</h2>

							<ul>
								{description?.map((desc) => (
									<li>
										<img src={bulletIcon} alt="" />
										<p className="mb-0">{desc}</p>
									</li>
								))}
							</ul>

							{noButton ? (
								""
							) : (
								<Button linkTo={link && link}>
									Learn more
								</Button>
							)}
						</div>
					</li>
				)
			)}
		</ul>
	);
}
